const numberFormatter = new Intl.NumberFormat("en-US")
const compactNumberFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 1,
  notation: "compact"
})
const dateTimeFormatter = new Intl.DateTimeFormat("en-US", {
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  month: "short"
})
const fullDateTimeFormatter = new Intl.DateTimeFormat("en-US", {
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  month: "short",
  second: "2-digit",
  timeZoneName: "short",
  year: "numeric"
})

export function formatNumber(value: number) {
  return numberFormatter.format(value)
}

export function formatBytes(value: number) {
  if (value < 1024) {
    return `${value} B`
  }

  const units = ["KB", "MB", "GB", "TB"]
  let size = value / 1024
  let index = 0

  while (size >= 1024 && index < units.length - 1) {
    size /= 1024
    index += 1
  }

  return `${size.toFixed(size >= 10 ? 0 : 1)} ${units[index]}`
}

export function formatCompact(value: number) {
  return compactNumberFormatter.format(value)
}

export function formatDuration(seconds: number) {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)

  if (hours > 0) {
    return `${hours}h ${minutes}m`
  }

  return `${minutes}m`
}

export function formatRelative(timestamp: number, now = Date.now()) {
  const diffSeconds = Math.max(1, Math.round((now - timestamp) / 1000))

  if (diffSeconds < 60) {
    return `${diffSeconds}s ago`
  }

  const diffMinutes = Math.round(diffSeconds / 60)
  if (diffMinutes < 60) {
    return `${diffMinutes}m ago`
  }

  const diffHours = Math.round(diffMinutes / 60)
  if (diffHours < 24) {
    return `${diffHours}h ago`
  }

  return dateTimeFormatter.format(timestamp)
}

export function formatFutureRelative(timestamp: number, now = Date.now()) {
  const diffSeconds = Math.max(1, Math.round((timestamp - now) / 1000))

  if (diffSeconds < 60) {
    return `in ${diffSeconds}s`
  }

  const diffMinutes = Math.round(diffSeconds / 60)
  if (diffMinutes < 60) {
    return `in ${diffMinutes}m`
  }

  const diffHours = Math.round(diffMinutes / 60)
  if (diffHours < 24) {
    return `in ${diffHours}h`
  }

  return dateTimeFormatter.format(timestamp)
}

export function formatTimestamp(timestamp: number) {
  return fullDateTimeFormatter.format(timestamp)
}

export function compactPrefixedId(value: string, prefix: string): string {
  const marker = `${prefix}_`
  if (!value.toLowerCase().startsWith(marker)) {
    return value
  }

  const suffix = value.slice(marker.length)
  return `${value.slice(0, marker.length)}${suffix.slice(0, 6)}`
}
